module.exports = __webpack_public_path__ + "static/media/communication.822711fd.jpeg";